import moment from 'moment';
export const displayChatTime = (date) => {
    const now = moment();
    if (now.isSame(date, 'date')) {
        return moment(date).format('LT');
    }
    else if (now.isSame(date, 'week')) {
        return moment(date).format('ddd');
    }
    else
        return moment(date).format('ll');
};
export const displayNotificationTime = (date) => {
    const fromNow = moment(date).fromNow();
    return fromNow;
};
export const displayMessageTime = (date) => {
    return moment(date).format('LT');
};
export const displayDate = (date) => {
    const momentDate = moment(date);
    const now = moment();
    if (momentDate.isSame(now, 'day')) {
        return 'Today';
    }
    if (momentDate.isSame(now.subtract(1, 'days'), 'day')) {
        return 'Yesterday';
    }
    return momentDate.format('LL');
};
export const displayTimeToRace = (date) => {
    const momentDate = moment(date);
    const nowDate = moment();
    const days = moment(momentDate).diff(nowDate, 'days');
    const hours = moment(momentDate).diff(nowDate, 'hours');
    const hoursDiff = hours - days * 24;
    return `${days}d ${hoursDiff}h`;
};
